import Navigation from '@pelckmans/elementis/components/navigation';
import MethodsIcon from '@pelckmans/elementis/icons/methods';
import UserIcon from '@pelckmans/elementis/icons/user';
import UsersIcon from '@pelckmans/elementis/icons/users';
import Badge from '@pelckmans/elementis/components/badge';
import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import IdentityContext from '../../../contexts/IdentityContext';
import { useRoutes } from '../../../hooks/useRoutes';
import InvitationContext from '../../../contexts/InvitationContext';
import useLicenses from '../../../hooks/useLicenses';
import useStudioGroup from '../../../hooks/useStudioGroup';
import PelckmansLogo from '../../sidebar/components/PelckmansLogo';
import User from '../../sidebar/components/User';
import { LICENSE_TRANSFER_DIRECTION } from '../../../pages/my-profile/api/licenses';

function ApplicationNavigation() {
  const { buildAbsolutePath } = useRoutes();
  const { t } = useTranslation();

  const { identity } = useContext(IdentityContext);
  const { pendingInvitations, licenseTransfers } = useContext(InvitationContext);
  const { hasGroupFeatures } = useLicenses();
  const studioGroup = useStudioGroup();

  const breakpoint = useBreakpoint();

  const isMobile = breakpoint === 'mobile';
  const isCodeBased = studioGroup === 'BAO' || studioGroup === 'VO';
  const showGroupsAndProfile = identity.isTeacherAlike || !isCodeBased;

  const incomingLicenseTransfers = licenseTransfers.filter(x => x.direction === LICENSE_TRANSFER_DIRECTION.RECEIVER);

  return (
    <header className="application-navigation">
      <div className="content">
        {isMobile && <PelckmansLogo />}
        <Navigation className="middle-navigation">
          <Navigation.List orientation="horizontal">
            <Navigation.Item
              icon={<MethodsIcon />}
              to={buildAbsolutePath(['MY_METHODS', 'MY_METHODS.DASHBOARD'])}
              iconOnly={isMobile}
              end={false}
            >
              {t('APP_NAV.TOP_NAV.MY_METHODS')}
            </Navigation.Item>

            {identity.isTeacherAlike && hasGroupFeatures() && (
              <Navigation.Item
                icon={<UsersIcon />}
                to={buildAbsolutePath(['MY_GROUPS'])}
                iconOnly={isMobile}
                end={false}
              >
                {t('APP_NAV.TOP_NAV.MY_GROUPS')}
              </Navigation.Item>
            )}

            {!identity.isTeacherAlike && showGroupsAndProfile && (
              <Navigation.Item
                badge={pendingInvitations.length > 0 ? <Badge>{pendingInvitations.length}</Badge> : undefined}
                icon={<UsersIcon />}
                to={buildAbsolutePath(['MY_TEACHERS'])}
                iconOnly={isMobile}
                end={false}
              >
                {t('APP_NAV.TOP_NAV.MY_TEACHERS')}
              </Navigation.Item>
            )}

            {showGroupsAndProfile && (
              <Navigation.Item
                badge={
                  incomingLicenseTransfers.length > 0 ? <Badge>{incomingLicenseTransfers.length}</Badge> : undefined
                }
                icon={<UserIcon />}
                to={
                  incomingLicenseTransfers.length > 0
                    ? buildAbsolutePath(['MY_PROFILE', 'MY_PROFILE.LICENSES'])
                    : buildAbsolutePath(['MY_PROFILE'])
                }
                iconOnly={isMobile}
                end={false}
              >
                {t('APP_NAV.TOP_NAV.MY_PROFILE')}
              </Navigation.Item>
            )}
          </Navigation.List>
        </Navigation>
        {isMobile && <User />}
      </div>
    </header>
  );
}

export default ApplicationNavigation;
